import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { manageSchedaDisabled, manageScObbl } from '../common/helper/scheda-settore.helper';
import { CoopDettagliantiFormValidators } from './validators/coop-dettaglianti-form-validators';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { DatiIdentificativiFormService } from '../../dati-identificativi/dati-identificativi-form.service';
import { formPaths } from '@shared/constants/form-paths.const';

@Injectable()
export class SchedaCoopDettagliantiFormService extends BaseRevisioneFormService {
    isDisabled$: Observable<boolean>;

    constructor(protected datiIdentificativiService: DatiIdentificativiFormService) {
        super(undefined, undefined, datiIdentificativiService);
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_SchedaCoopDettaglianti: this.fb.group({
                        my_ScCoopDettagliObbl: '',
                        my_GroupDetta: '',
                        my_SchDettAcqColl: '',
                        my_SchDettServAmm: '',
                        my_SchDettServFin: '',
                        my_SchDettGestMercRion: '',
                        my_SchDettLogistica: '',
                        my_SchDettAltro: '',
                        my_SchDettNoteOsserv: '',
                        my_CkSchDettAcqColl: '',
                        my_CkSchDettServAmm: '',
                        my_CkSchDettServFin: '',
                        my_CkSchDettGestMercRion: '',
                        my_CkSchDettLogistica: '',
                        my_CkSchDettAltro: '',
                        my_CkSchDettNoteOsserv: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: CoopDettagliantiFormValidators,
            }
        );
    }

    protected override afterFormInitialize(): void {
        this._manageDeactivation();
        manageScObbl(this.datiIdentificativiFormService, this._form, `${formPaths.schedaCoopDettaglianti}.my_ScCoopDettagliObbl`);
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScCoopDettagliObbl);
    }
}
